<template>
  <div class="error_container"></div>
</template>
<script>
export default {
  name: "error",
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style scoped lang="scss">
.error_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  background-image: url(~@/assets/images/error.png);
  background-size: 40% auto;
  background-repeat: no-repeat;
  background-position: center 35%;
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>